import { render, staticRenderFns } from "./ptTableRowKeno.vue?vue&type=template&id=270b61c0&lang=pug&"
import script from "./ptTableRowKeno.vue?vue&type=script&lang=js&"
export * from "./ptTableRowKeno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports